import { observer } from "mobx-react-lite";
import React from "react";
import { HelpInput } from "./inputs/default/HelpInput";
import { HiddenCheckbox } from "./inputs/default/HiddenCheckbox";
import { LabelInput } from "./inputs/default/LabelInput";
import { RequiredCheckbox } from "./inputs/default/RequiredCheckbox";

type Props = {};

export const DefaultConfigInput = observer((props: Props) => {
  return (
    <>
      <HiddenCheckbox />
      <RequiredCheckbox />
      <LabelInput />
      <HelpInput />
    </>
  );
});
